import { notifications } from '@mantine/notifications';
import { QueryClient } from '@tanstack/react-query';
import { ApiError, errorMessage } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      retry: (count, error) => {
        if (error instanceof ApiError && error.status > 0 && error.status < 500) return false;
        return count < 2;
      },
    },
    mutations: { retry: false },
  },
});

export function notifyError(error: unknown, title = 'Could not save'): void {
  notifications.show({ color: 'red', title, message: errorMessage(error) });
}

export function notifySuccess(message: string, title?: string): void {
  notifications.show({ color: 'green', title, message });
}
